import "./MoreButton.css"

export default function MoreButton({onPress}) {
    return (
        <div className={"detail-more-button"} onClick={onPress}>MORE</div>
    )
}